/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class ProfilesCompaniesClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Retrieves the Public Company Profile specified by the public url slug.
     *
     * A Public Company Profile makes available the following information: <ul><li>Company Name</li><li>Company Logo Url</li><li>Description</li><li>Website</li></ul>
     *
     * @param urlSlug Documentation pending
     */
    retrievePublicCompanyProfile(urlSlug) {
        const url = `/api/v1/profiles/companies/${urlSlug}`;
        return this.client.request("get", url, null, null);
    }
    /**
     * Queries Public Company Profiles
     *
     * More information on querying can be found on the [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight) page on the Lockstep Developer website.
     *
     * A Public Company Profile makes available the following information:
     *
     * <ul><li>Company Name</li><li>Company Logo Url</li><li>Description</li><li>Website</li></ul>
     *
     * @param filter The filter for this query. See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param order The sort order for the results, in the [Searchlight order syntax](https://github.com/tspence/csharp-searchlight).
     * @param pageSize The page size for results (default 250, maximum of 500)
     * @param pageNumber The page number for results (default 0)
     */
    queryPublicCompanyProfiles(filter, order, pageSize, pageNumber) {
        const url = `/api/v1/profiles/companies/query`;
        const options = {
            params: {
                filter,
                order,
                pageSize,
                pageNumber,
            },
        };
        return this.client.request("get", url, options, null);
    }
}
//# sourceMappingURL=ProfilesCompaniesClient.js.map